var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0532 31.0012C10.5009 31.0012 10.0532 31.4489 10.0532 32.0012C10.0532 32.5534 10.5009 33.0012 11.0532 33.0012L11.0532 31.0012ZM52.9464 32.0012L53.6535 32.7083C53.841 32.5207 53.9464 32.2664 53.9464 32.0012C53.9464 31.7359 53.841 31.4816 53.6535 31.294L52.9464 32.0012ZM34.2314 11.872C33.8409 11.4815 33.2077 11.4815 32.8172 11.872C32.4267 12.2625 32.4267 12.8957 32.8172 13.2862L34.2314 11.872ZM32.8172 50.7161C32.4267 51.1066 32.4267 51.7398 32.8172 52.1303C33.2077 52.5208 33.8409 52.5208 34.2314 52.1303L32.8172 50.7161ZM11.0532 33.0012L52.9464 33.0012L52.9464 31.0012L11.0532 31.0012L11.0532 33.0012ZM53.6535 31.294L34.2314 11.872L32.8172 13.2862L52.2393 32.7083L53.6535 31.294ZM52.2393 31.294L32.8172 50.7161L34.2314 52.1303L53.6535 32.7083L52.2393 31.294Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
